module.exports = __webpack_public_path__ + "img/check_in.ec42698d.svg";